import React from 'react'
import "./header.css";
import logoImage from "../../assets/logo.svg"

function Header() {
  return (
    <div className="header">
      <a href="https://www.engagedigital.ai" className="logo">
        <img src={logoImage} className="logo" alt="" />
      </a>
      <h3 className="engageTitle1">Registration Form</h3>
    </div>
  );
}

export default Header;